<template>
  <transition name="fade">
    <template>
      <div class="field-group">
        <!-- Temporarily hardcoding the hasContent class so the label shows always for this component -->
        <label :for="'product_attribute_' + attribute.Id" class="animated hasContent" v-if="!fullWidth">
          <span class="fixed-label new">{{ attribute.Name | attributeHeadline }}</span>
          <span class="animated-label">{{ attribute.Name | attributeHeadline }}</span>
        </label>
        <div
          class="date-wrapper fill-width"
          v-bind:class="{ 'multipleDates': isMultipleDates, 'full-width-calendar': fullWidth }"
        >
          <input
            type="text"
            ref="datepickerInput"
            class="datepicker-here fill-width attribute-field"
            :name="controlId"
            :data-productattrid="attribute.Id"
            :data-attrid="attribute.Id"
            :data-attrname="attribute.Name"
            :id="controlId"
            v-model="attribute.SelectedValueId"
            :placeholder="placeholder"
            :class="{ hidden: isMultipleDates, highlight: highlightField }"
            readonly
          />
          <input
            type="text"
            class="hidden"
            v-if="isMultipleDates"
            v-model="multipleDatesValue"
            :name="'rental_start_date_' + attribute.ProductId"
            :id="'rental_start_date_' + attribute.ProductAttributeId"
          />
        </div>
        <input
          type="text"
          class="hidden"
          :id="controlId + '_day'"
          :name="controlId + '_day'"
          v-model="attribute.SelectedDay"
        />
        <input
          type="text"
          class="hidden"
          :id="controlId + '_month'"
          :name="controlId + '_month'"
          v-model="attribute.SelectedMonth"
        />
        <input
          type="text"
          class="hidden"
          :id="controlId + '_year'"
          :name="controlId + '_year'"
          v-model="attribute.SelectedYear"
        />
      </div>
    </template>
  </transition>
</template>
<script>
import '@nop-js/air-datepicker'
import moment from 'moment'

import { mapGetters } from 'vuex'

export default {
  name: 'inventory-date-picker',
  data() {
    return {
      defaultDateSet: false,
      dateElement: null,
      datePicker: null,
      placeholder: null,
      isMultipleDates: false,
      multipleDatesValue: '',
      currentDateInventory: null,
    }
  },
  props: {
    attribute: {
      type: Object,
    },
    highlightMissingDate: {
      type: Boolean,
      default: false,
    },
    displayInline: {
      type: Boolean,
      default: false,
    },
    fullWidth: {
      type: Boolean,
      default: false,
    },
    initialDate: {
      type: Date,
      default() {
        return new Date()
      },
    },
  },
  created: function () {
    this.setPlaceholder()
    this.setMetadata()
  },
  mounted: function () {
    var self = this
    this.dateElement = $(this.$refs.datepickerInput)

    var multipleDates = this.attribute.TextPrompt ? this.attribute.TextPrompt.indexOf('[Multiple Dates]') > -1 : false
    var multipleDatesSetting = null

    self.$store.commit('products/setCalendarMonth', this.minDate.getMonth() + 1)
    self.$store.commit('products/setCalendarYear', this.minDate.getFullYear())

    if (multipleDates) {
      multipleDatesSetting = this.productNumberOfDays && this.productNumberOfDays > 1 ? this.productNumberOfDays : true
    } else {
      multipleDatesSetting = false
    }

    this.datePicker = this.dateElement.datepicker({
      language: this.language,
      autoClose: true,
      startDate: this.defaultDate || this.initialDate,
      minDate: self.minDate,
      maxDate: self.maxDate,
      multipleDates: multipleDatesSetting,
      multipleDatesSeparator: '|',
      inline: multipleDates || this.displayInline,
      toggleSelected: true,
      selectOtherMonths: false,
      onSelect: function (formattedDate, date, inst) {
        var newDate = Array.isArray(date) ? date[0] : date
        var attributeDateList = Array.isArray(date) ? date : new Array(date)
        var dateIndex = newDate ? newDate.getDate() - 1 : null

        var selDay = newDate ? newDate.getDate() : null
        var selMonth = newDate ? newDate.getMonth() + 1 : null
        var selYear = newDate ? newDate.getFullYear() : null

        if (self.isMultipleDates) {
          if (self.multipleDatesValue.length > 0 && date.length > 0) {
            var dateCheck = date.filter((item) => {
              var found = false
              self.multipleDatesValue.forEach(function (d) {
                if (_.isEqual(d, item)) {
                  found = true
                }
              })
              return !found
            })
            if (dateCheck[0]) {
              newDate = dateCheck[0]
            }

            selDay = newDate ? newDate.getDate() : null
            selMonth = newDate ? newDate.getMonth() + 1 : null
            selYear = newDate ? newDate.getFullYear() : null
          }

          self.multipleDatesValue = date
        }

        if (attributeDateList && !attributeDateList[0]) {
          attributeDateList = []
        }

        self.$store.commit('products/setSelectedProductDates', attributeDateList)
        self.$store.commit('products/setSelectedProductDateIndex', dateIndex)
        self.$set(
          self.attribute,
          'SelectedDates',
          attributeDateList.map((iDate) => {
            var year = iDate.getFullYear()
            var month = iDate.getMonth() + 1
            var date = iDate.getDate()

            return `${year}-${month}-${date}`
          })
        )
        self.$set(self.attribute, 'SelectedValue', formattedDate)
        self.$set(self.attribute, 'SelectedValueId', formattedDate)
        if (selDay) {
          self.$set(self.attribute, 'SelectedDay', selDay)
        }
        if (selMonth) {
          self.$set(self.attribute, 'SelectedMonth', selMonth)
        }
        if (selYear) {
          self.$set(self.attribute, 'SelectedYear', selYear)
        }

        var loadPrice = !!this.defaultDateSet

        // Ensure all data model variables have been set before triggering the attribute changed event.
        // This is useful for Month, Day, Year input bindings.
        self.$nextTick(function () {
          self.textAttributeChanged(loadPrice, false)
        })

        this.defaultDateSet = true
      },
      onRenderCell: function (date, cellType) {
        let classes = ''
        let isDisabled = false
        let html = '<span>' + date.getDate() + '</span>'

        const inventoryDate = self.dateInventory.get(date.toLocaleDateString(storeSettings.Locale))

        const cellDate = self.timeAtResort.clone().date(date.getDate()).month(date.getMonth()).year(date.getFullYear())
        if (cellDate.startOf('day').isBefore(self.earliestPurchaseDate.startOf('day'))) {
          isDisabled = true
        }

        if (inventoryDate) {
          _.each(inventoryDate, function (rule) {
            if (rule === 'lowInventory' || rule === 'lowPricingInventory') {
              classes += ' -lowinventory-'
            } else if (rule === 'noInventory' || rule === 'noPricingInventory') {
              classes += ' -noinventory-'
              html = '<span title="no inventory available this day">' + date.getDate() + '</span>'
              isDisabled = true
            }
          })
        }

        if (cellType === 'day') {
          return {
            disabled: isDisabled,
            classes: classes,
            html: html,
          }
        }
      },
      onChangeMonth: function onChangeMonth(month, year) {
        self.$store.commit('products/setCalendarMonth', month + 1)
        self.$store.commit('products/setCalendarYear', year)
        self.$emit('month-changed', month + 1, year)
      },
      onHide: function (inst, animationCompleted) {
        let newDate = self.defaultDate || self.initialDate
        if (self.attribute.SelectedValueId) {
          newDate = new Date(self.attribute.SelectedValueId)
        }
        self.viewDatePickerDate(newDate)
      },
    })

    if (this.attribute.DefaultValue) {
      // IMPORTANT: This replace command is needed to resolve the fact that safari calculates a date one day earlier for
      //            dates that are in the yyyy-mm-dd format
      const defaultValueDateString = this.attribute.DefaultValue.replace(/-/g, '\/')
      const defaultValueDate = new Date(defaultValueDateString)

      const defaultMomentDate = this.timeAtResort
        .clone()
        .date(defaultValueDate.getDate())
        .month(defaultValueDate.getMonth())
        .year(defaultValueDate.getFullYear())
      if (defaultMomentDate.startOf('day').isSameOrAfter(this.earliestPurchaseDate.startOf('day'))) {
        this.dateElement.datepicker().data('datepicker').selectDate(defaultValueDate)
      }
    }
  },
  methods: {
    clearAttributeSelection: function () {
      this.attribute.SelectedValue = null
      this.attribute.SelectedValueId = null
    },
    reinitializeDatePicker: function () {
      if (this.dateElement.data('datepicker')) {
        this.dateElement.data('datepicker').update({
          inline: true,
        })
      }
    },
    viewDatePickerDate: function (viewDate) {
      if (this.dateElement.data('datepicker')) {
        this.dateElement.data('datepicker').date = viewDate
      }
    },
    updateMultiDay: function (dayCount) {
      if (this.dateElement.data('datepicker') && this.isMultipleDates) {
        if (dayCount < 2) {
          this.dateElement.data('datepicker').update({
            multipleDates: false,
          })
        } else {
          this.dateElement.data('datepicker').update({
            multipleDates: dayCount,
          })
        }
      }
    },
    inventoryFact: function (params, almanac) {
      return almanac.factValue('date').then((dateIndex) => {
        return this.inventory ? this.inventory[dateIndex - 1] : null
      })
    },
    pricingInventoryFact: function (params, almanac) {
      return almanac.factValue('date').then((dateIndex) => {
        return this.pricingInventory ? this.pricingInventory[dateIndex - 1] : null
      })
    },
    setPlaceholder: function () {
      var placeholder = this.attribute.TextPrompt ? this.attribute.TextPrompt : null
      var objectRegex = /\{.*\}/
      if (placeholder) {
        placeholder = placeholder.replace(objectRegex, '').trim()
        if (placeholder.length > 0) {
          this.placeholder = this.filters.stripAttributeFields(placeholder)
        } else {
          this.placeholder = this.filters.attributeHeadline(attribute.Name)
        }
      } else {
        this.placeholder = this.filters.attributeHeadline(attribute.Name)
      }
    },
    setMetadata: function () {
      if (this.attribute.TextPrompt) {
        this.isMultipleDates = this.attribute.TextPrompt.indexOf('[Multiple Dates]') > -1
      }
      // Alternate way of indicating the calendar should be using multiday - uses dynamic pricing settings
      if (this.isNonConsecutiveMultiDay) {
        this.isMultipleDates = true
      }
    },
    textAttributeChanged: function (loadPrice, updateInventory) {
      loadPrice = loadPrice !== undefined ? loadPrice : true
      var value = this.selectedProductAttribute
      var attrib = {
        Id: this.attribute.Id,
        ProductAttributeId: this.attribute.ProductAttributeId,
        ProductAttributeValue: value,
      }
      this.$emit('attribute-changed', false)
    },
    attributeChanged: function (attrib, checked, loadPrice, event) {
      if (checked) {
        this.$set(this.attribute, 'SelectedValueId', this.filters.attributeHeadline(attrib.Name))
      } else {
        this.$set(this.attribute, 'SelectedValueId', null)
      }

      this.$emit('attribute-changed')
    },
  },
  computed: {
    localShortDateFormat() {
      datehelpers.getShortDateFormat()
    },
    filters: function () {
      return this.$options.filters
    },
    highlightField: function () {
      if (this.highlightMissingDate && !this.attribute.SelectedValueId) {
        return true
      }
      return false
    },
    defaultDate: function () {
      let defaultDateString = this.attribute.DefaultValue
      if (!_.isEmpty(defaultDateString)) {
        defaultDateString = defaultDateString.replace(/-/g, '\/')
        return new Date(defaultDateString)
      }

      return null
    },
    inventoryUpdating: function () {
      return this.$store.getters['products/inventoryUpdating']
    },
    controlId: function () {
      return this.attribute ? 'product_attribute_' + this.attribute.Id : null
    },
    minDate: function () {
      return this.earliestPurchaseDate.toDate()
    },
    maxDate: function () {
      return this.$store.getters['global/seasonEnd'].toDate()
    },
    earliestPurchaseDate: function () {
      return this.$store.getters['products/selectedProductEarliestPurchaseDate']
    },
    defaultProductDate: function () {
      return this.$store.getters['products/selectedProduct']
        ? this.$store.getters['products/selectedProduct.DefaultDate']
        : null
    },
    dateInventory() {
      return this.$store.getters['products/dateInventory']
    },
    inventory() {
      return this.$store.getters['products/selectedProductInventory']
    },
    pricingInventory() {
      return this.$store.getters['products/selectedProductPricingInventory']
    },
    disabled: function () {
      return this.attribute.Disabled
    },
    selectedValue: function () {
      return this.attribute.SelectedValue
    },
    selectedValueId: function () {
      return this.attribute.SelectedValueId
    },
    productNumberOfDays: function () {
      return this.$store.getters['products/selectedProductNumberOfDays']
        ? this.$store.getters['products/selectedProductNumberOfDays']
        : null
    },
    isNonConsecutiveMultiDay: function () {
      return this.$store.getters['products/selectedProduct']
        ? this.$store.getters['products/selectedProduct'].IsNonConsecutiveMultiDay
        : false
    },
    isConsecutiveMultiDay: function () {
      return this.$store.getters['products/selectedProduct']
        ? this.$store.getters['products/selectedProduct'].IsConsecutiveMultiDay
        : false
    },
    ...mapGetters({
      language: 'global/language',
      storeTimezoneOffset: 'global/storeTimezoneOffset',
      timeAtResort: 'global/timeAtResort',
    }),
  },
  watch: {
    selectedValue: function () {
      if (!this.selectedValue) {
        this.selectedProductAttribute = null
      }
    },
    selectedValueId: function () {
      if (this.attribute.AttributeControlType === 20) {
        if (!this.selectedValueId) {
          this.dateElement.data('datepicker').clear()
        }
      }
    },
    dateInventory: function () {
      if (this.attribute.AttributeControlType === 20) {
        this.reinitializeDatePicker()
      }
    },
    inventoryUpdating: function () {
      if (this.inventoryUpdating) {
        $('#datepickers-container').addClass('loading')
        $('.date-wrapper').addClass('loading')
      } else {
        $('#datepickers-container').removeClass('loading')
        $('.date-wrapper').removeClass('loading')
      }
    },
    productNumberOfDays: function () {
      this.updateMultiDay(this.productNumberOfDays)
    },
  },
}
</script>
